import * as THREE from 'three';

/**
 * 创建 WebGL 渲染器
 * Apple 风格配置：高性能、抗锯齿
 */
export function createRenderer(
  canvas: HTMLCanvasElement,
  width: number,
  height: number
): THREE.WebGLRenderer {
  const renderer = new THREE.WebGLRenderer({
    canvas,
    antialias: true,           // 开启抗锯齿
    alpha: false,              // 不使用透明背景
    powerPreference: 'high-performance' // 高性能模式
  });

  // 设置渲染器尺寸
  renderer.setSize(width, height);

  // 设置像素比 - 限制最大为 1.5 以提升性能
  renderer.setPixelRatio(Math.min(window.devicePixelRatio, 1.5));

  // 禁用阴影 - 性能优化（不需要真实阴影）
  renderer.shadowMap.enabled = false;

  // 颜色空间
  renderer.outputColorSpace = THREE.SRGBColorSpace;
  renderer.toneMapping = THREE.ACESFilmicToneMapping;
  renderer.toneMappingExposure = 1.0;

  // 禁用日志警告
  renderer.info.autoReset = false;

  return renderer;
}

/**
 * 更新渲染器尺寸
 */
export function resizeRenderer(
  renderer: THREE.WebGLRenderer,
  camera: THREE.PerspectiveCamera,
  width: number,
  height: number
): void {
  renderer.setSize(width, height);
  camera.aspect = width / height;
  camera.updateProjectionMatrix();
}

/**
 * 创建 CSS3D 渲染器 (用于 UI 元素)
 */
export function createCSS3DRenderer(): void {
  // CSS3D 渲染器用于将 HTML 元素放入 3D 空间
  // 如需使用可添加 three/examples/jsm/renderers/CSS3DRenderer.js
}

/**
 * 性能统计信息
 */
export interface RendererStats {
  fps: number;
  drawCalls: number;
  triangles: number;
  geometries: number;
  textures: number;
}

/**
 * 获取渲染器统计信息
 */
export function getRendererStats(renderer: THREE.WebGLRenderer): RendererStats | null {
  const info = renderer.info;
  if (!info) return null;

  return {
    fps: 0, // FPS 需要单独计算
    drawCalls: info.render.calls,
    triangles: info.render.triangles,
    geometries: info.memory.geometries,
    textures: info.memory.textures
  };
}
